import ButtonTime from './src/main'

ButtonTime.install = function (Vue) {
    Vue.component(ButtonTime.name, ButtonTime)
}

export default ButtonTime